/*
 * File: PatientCardTitle.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates the patient card first and last name display
 */
import React, { Component } from "react";
import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";

class PatientCardTitle extends Component {
  state = { alertsOpen: false };

  toggleAlerts = () => {
    this.setState({ alertsOpen: !this.state.alertsOpen });
  };

  render() {
    let { lastName, firstName, displayId, hasAlerts } = this.props;
    return (
      <React.Fragment>
        <Typography variant="subtitle1">
          {lastName}, {firstName} ({displayId})
        </Typography>
        {hasAlerts && (
          <React.Fragment>
            {/*
            <PatientAlertIcons onClick={this.toggleAlerts} />
            <PatientAlerts open={open} />
        */}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

PatientCardTitle.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  displayId: PropTypes.string,
  hasAlerts: PropTypes.bool
};

export default PatientCardTitle;
